module.exports = __webpack_public_path__ + "media/rating-scale.a288f4b8.webm";